import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgUploadIconSecondary from './svgs/UploadIconSecondary.js';
import SvgUploadIcon from './svgs/UploadIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var uploadIcon = (props => useIcon(SvgUploadIcon, SvgUploadIconSecondary, props));

export { uploadIcon as default };
